import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './colors.css';

import App from './App';
import './design-refresh.css';
import './design-soft.css';

console.error = (function(_error) {
  return function(message) {
    if (typeof message !== 'string' || message.indexOf('component is `contentEditable`') === -1) {
      _error.apply(console, arguments)
    }
  }
})(console.error)
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

